import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { IdentityVerificationMethod, MessageService, SsoAccountCheckoutState, SsoAccountFacade } from "common";
import { Observable, of } from "rxjs";
import { catchError, mapTo, switchMap, take } from "rxjs/operators";
import { CustomerCheckoutService } from "../../../customer/customer-checkout/customer-checkout.service";

@Injectable({
  providedIn: "root",
})
export class VerifyIdentityGuard implements CanActivate {
  constructor(
    private readonly ssoAccountFacade: SsoAccountFacade,
    private readonly customerCheckoutService: CustomerCheckoutService,
    private readonly messageService: MessageService,
  ) { }

  canActivate(): Observable<boolean> {
    return this.ssoAccountFacade.getSsoAccountCheckoutState$().pipe(
      take(1),
      switchMap((checkoutState: SsoAccountCheckoutState) => this.validate(checkoutState))
    );
  }

  private validate(checkoutState: SsoAccountCheckoutState): Observable<boolean> {
    const method = checkoutState?.method;
    
    if (method === IdentityVerificationMethod.IDVerse) {
      return of(true);
    }

    if (method === IdentityVerificationMethod.KBA) {
      return this.customerCheckoutService.getQuestions().pipe(
        mapTo(true),
        catchError((error) => {
          this.messageService.error(error);
          return of(false);
        })
      );
    }

    this.messageService.error('Unsupported identity verification method. Please contact your Business Advisor.');
    return of(false);
  }
}
